<template>
    <div class="ReportsPane">
        <div class="container-fluid container-fill">
            <div class="row">
                <div class="col-md-4">
                    <h4>Census Reports</h4>
                    <ReportDownloader report-label="Child Birthdays"
                                      endpoint="Core/Reports/ProgramReports/GetBirthdays"
                                      :parameter-schema="ParamsClientBirthdayOptions"
                                      report-description="Lists the birthdays of current children, with options to specify the level of privacy on the generated list." />
                    <ReportDownloader report-label="Youth Roster"
                                      endpoint="Tay/Reports/ProgramReports/ClientRoster"
                                      :parameter-schema="ParamsSubProgramStartEnd"
                                      report-description="Lists of youth entrolled in selected program at least one day during the timeframe indicated.  For current roster, set both Start and End dates as current date." />

                    <ReportDownloader report-label="Census by Territory"
                                      endpoint="Tay/Reports/ProgramReports/TayCensus"
                                      :parameter-schema="ParamsSubProgramStartEnd"
                                      report-description="Lists census metrics in total for program, and split by territory" />


                    <ReportDownloader report-label="PNW Billing Report Data"
                                      endpoint="Tay/Reports/ProgramReports/PNWILSBillingReport"
                                      :parameter-schema="ParamsMonthYearCatchement"
                                      report-description="Generates Data that can be dropped into WA ILS DCYF Billing Report."
                                      permission-requirement="PNWILSReports" />
                    <ReportDownloader report-label="PNW FYI Billing Report Data"
                                      endpoint="Tay/Reports/ProgramReports/PNWILSTravelLogReport"
                                      :parameter-schema="ParamsStartEnd"
                                      report-description="Generates Travel Log data for the specified date range."
                                      permission-requirement="PNWILSReports" />
                    <ReportDownloader report-label="PNW Quarterly/Annual Report"
                                      endpoint="Tay/Reports/ProgramReports/PNWILSQuarterlyAnnualReport"
                                      :parameter-schema="ParamsStartEndCatchement"
                                      report-description="Generates Data that can be dropped into the WA ILS DCYF Annual or Quarterly Report"
                                      permission-requirement="PNWILSReports" />
                    <ReportDownloader report-label="PNW HHP Census Report"
                                      endpoint="Tay/Reports/ProgramReports/PNWILSHHPCensusReport"
                                      :parameter-schema="ParamsStartEndRegion"
                                      report-description="Generates Data that can be dropped into the WA HHP Census Report"
                                      permission-requirement="PNWILSReports" />
                    <ReportDownloader report-label="Caseload Report"
                                      endpoint="TAY/Reports/ProgramReports/CaseManagerCaseloadReport"
                                      :parameter-schema="ParamsSubProgramCaseloadOptions"
                                      report-description="Provides a list of youth, grouped by Case Manager, with caseload counts (Excel)" />

                </div>
                <div class="col-md-4">
                    <h4>Misc Reports</h4>

                    <ReportDownloader report-label="Discharge Outcomes By Employee"
                                      permission-requirement="Tay.Employees.Productivity"
                                      endpoint="Core/Reports/ProgramReports/DischargeOutcomesByEmployee"
                                      :parameter-schema="ParamsSubProgramStartEnd"
                                      report-description="Provides a list that shows average length of stay by Caseload Assignment" />

                    <ReportDownloader report-label="Riverside Case Note Summary"
                                      endpoint="Tay/Reports/ProgramReports/RiversideTHPCaseNoteSummary"
                                      :parameter-schema="ParamsStartEnd"
                                      report-description="Lists Case Notes in the specified range, and totals progress and points metrics."
                                      permission-requirement="RiversideTHPReports" />
                    <ReportDownloader report-label="PNW NYTD Elements Summary"
                                      endpoint="Tay/Reports/ProgramReports/PNWILSNYTDElementsSummary"
                                      :parameter-schema="ParamsStartEnd"
                                      report-description="Lists NYTD Elements covered for each youth in the target time period."
                                      permission-requirement="PNWILSReports" />

                    <ReportDownloader report-label="Group Sessions"
                                      endpoint="TAY/Reports/ProgramReports/GroupSessionsReport"
                                      :parameter-schema="ParamsStartEndCatchementOptional"
                                      report-description="Lists all group sessions for specified date range and catchement area"
                                      persmission-requirement="PNWILSReports" />
                </div>
                <div class="col-md-4">
                    <h4>Financial Reports</h4>
                    <ReportDownloader report-label="Census Verification"
                                      report-description="Downloads a list of activity for the period indicated.  An identical report can be emailed to the program's distribution list for approval/rejection."
                                      endpoint="Core/CensusApprovals/CreateCensusApproval"
                                      :parameter-schema="ParamsSubProgramStartEndReportType" />
                    <ReportDownloader report-label="Census Financials"
                                      report-description="Generates Revenue/Expense transactions for all billable activity in the specified month and year."
                                      endpoint="Core/CensusApprovals/TransactionsReport"
                                      permission-requirement="Reports.CensusFinancials"
                                      :parameter-schema="ParamsSubProgramMonthYear" />


                </div>

            </div>
        </div>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faList } from '@fortawesome/free-solid-svg-icons';
    library.add(faList);
    import { faChild } from '@fortawesome/free-solid-svg-icons';
    library.add(faChild);
    //import components
    import ReportDownloader from '../../Core/UI/ReportDownloader.vue';
    export default {
        props: [],
        data: function () {
            return {
                ParamsClientBirthdayOptions: [
                    {
                        Label: "Program:",
                        Name: "SubProgramId",
                        Type: "Select",
                        Required: true,
                        Options: []
                    },
                    {
                        Label: "Columns to Show:",
                        Type: "CheckBoxBool",
                        Required: false,
                        Options: [
                            {
                                text: "Include Last Name",
                                name: "IncludeLastName",
                                checked: true
                            },
                            {
                                text: "Include Date Of Birth",
                                name: "IncludeDateOfBirth",
                                checked: true
                            },
                            {
                                text: "Include Year Of Birth",
                                name: "IncludeYearOfBirth",
                                checked: true
                            },
                            {
                                text: "Include Month",
                                name: "IncludeDayOfMonth",
                                checked: true
                            },
                            {
                                text: "Include Day",
                                name: "IncludeDay",
                                checked: true
                            },
                            {
                                text: "Include Age",
                                name: "IncludeAge",
                                checked: true
                            },
                            {
                                text: "Include Gender",
                                name: "IncludeGender",
                                checked: true
                            }
                        ]
                    }
                ],
                ParamsSubProgramStartEnd: [
                    {
                        Label: "Program:",
                        Name: "SubProgramID",
                        Type: "Select",
                        Required: true,
                        Options: []
                    },
                    {
                        Label: "Start Date:",
                        Name: "StartDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "End Date:",
                        Name: "EndDate",
                        Type: "Date",
                        Required: true
                    }
                ],
                ParamsStartEnd: [
                    {
                        Label: "Start Date:",
                        Name: "StartDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "End Date:",
                        Name: "EndDate",
                        Type: "Date",
                        Required: true
                    }
                ],
                ParamsMonthYearCatchement: [
                    {
                        Label: "Month:",
                        Name: "Month",
                        Type: "Number",
                        Required: true
                    },
                    {
                        Label: "Year:",
                        Name: "Year",
                        Type: "Number",
                        Required: true
                    },
                    {
                        Label: "Catchement Area:",
                        Name: "CatchementArea",
                        Type: "Select",
                        Required: true,
                        Options: [
                            {
                                text: "5",
                                value: "5"
                            },
                            {
                                text: "6",
                                value: "6"
                            },
                            {
                                text: "7",
                                value: "7"
                            },
                        ]
                    },
                ],
                ParamsStartEndCatchement: [
                    {
                        Label: "Start Date:",
                        Name: "StartDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "End Date:",
                        Name: "EndDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "Catchement Area:",
                        Name: "CatchementArea",
                        Type: "Select",
                        Required: true,
                        Options: [
                            {
                                text: "5",
                                value: "5"
                            },
                            {
                                text: "6",
                                value: "6"
                            },
                            {
                                text: "7",
                                value: "7"
                            },
                        ]
                    },
                ],
                ParamsStartEndRegion: [
                    {
                        Label: "Start Date:",
                        Name: "StartDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "End Date:",
                        Name: "EndDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "Region:",
                        Name: "CatchementArea",
                        Type: "Select",
                        Required: true,
                        Options: [
                            {
                                text: "5",
                                value: "5"
                            },
                            {
                                text: "6",
                                value: "6"
                            }
                        ]
                    },
                ],
                ParamsStartEndCatchementOptional: [
                    {
                        Label: "Start Date:",
                        Name: "StartDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "End Date:",
                        Name: "EndDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "Catchement Area:",
                        Name: "CatchementArea",
                        Type: "Select",
                        Required: false,
                        Options: [
                            {
                                text: "5",
                                value: "5"
                            },
                            {
                                text: "6",
                                value: "6"
                            },
                            {
                                text: "7",
                                value: "7"
                            },
                        ]
                    },
                ],
                ParamsSubProgramCaseloadOptions: [
                    {
                        Label: "Program:",
                        Name: "Id",
                        Type: "Select",
                        Required: true,
                        Options: []
                    },
                    {
                        Label: "Columns to Show:",
                        Name: "col_",
                        Type: "CheckBoxPrefixed",
                        Required: false,
                        Options: [
                            {
                                text: "Youth Name",
                                nameSuffix: "name",
                                checked: true
                            },
                            {
                                text: "DOB",
                                nameSuffix: "dob",
                                checked: true
                            },
                            {
                                text: "Program Enrollment",
                                nameSuffix: "loc",
                                checked: true
                            },
                            {
                                text: "Original Intake Date",
                                nameSuffix: "opd",
                                checked: false
                            },
                            {
                                text: "Location (city)",
                                nameSuffix: "location",
                                checked: true
                            },
                        ]
                    }
                ],
                ParamsSubProgramMonthYear: [
                    {
                        Label: "Program:",
                        Name: "SubProgramID",
                        Type: "Select",
                        Required: true,
                        Options: []
                    },
                    {
                        Label: "Month (1-12):",
                        Name: "Month",
                        Type: "Number",
                        Required: true
                    },
                    {
                        Label: "Year (4 digits):",
                        Name: "Year",
                        Type: "Number",
                        Required: true
                    },
                    {
                        Label: "Report Type:",
                        Name: "ReportType",
                        Type: "Select",
                        Required: true,
                        Options: [
                            {
                                text: "View Report Only",
                                value: "Download Only"
                            },
                            {
                                text: "Generate New Approval Email",
                                value: "Generate Approval Email"
                            },
                        ]
                    },
                ],
                ParamsSubProgramStartEndReportType: [
                    {
                        Label: "Program:",
                        Name: "SubProgramID",
                        Type: "Select",
                        Required: true,
                        Options: []
                    },
                    {
                        Label: "Start Date:",
                        Name: "StartDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "End Date:",
                        Name: "EndDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "Report Type:",
                        Name: "ReportType",
                        Type: "Select",
                        Required: true,
                        Options: [
                            {
                                text: "View Report Only",
                                value: "Download Only"
                            },
                            {
                                text: "Generate New Approval Email",
                                value: "Generate Approval Email"
                            },
                        ]
                    },
                ],
            };
        },
        methods: {

        },
        computed: {
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            },
        },
        components: {
            ReportDownloader
        },
        mounted() {
            let vm = this;
            this.ParamsClientBirthdayOptions[0].Options = this.SubProgramOptions;
            this.ParamsSubProgramStartEnd[0].Options = this.SubProgramOptions;
            this.ParamsSubProgramCaseloadOptions[0].Options = this.SubProgramOptions;
            this.ParamsSubProgramMonthYear[0].Options = this.SubProgramOptions;
            this.ParamsSubProgramStartEndReportType[0].Options = this.SubProgramOptions;
        }
    }
</script>

<style scoped>
</style>